import React, { useState } from "react";
import styles from "./BookACall.module.scss";
import Btn from "../Button/Button";
import { DISABLED, LOADING } from "../../store/actions/types";

/**
 * BookACall modal component that allows users to book an introductory call
 * with the QMENTA team to gain access to the platform.
 *
 * @component
 *
 * @param {Object} props - Component props
 * @param {Function} props.onClickBookACall - Callback invoked when the user clicks the "Book a Call" button.
 * @param {Function} props.onClickCancelButton - Callback invoked when the user cancels the booking or clicks outside the modal (unless in LOADING state).
 *
 * @returns {JSX.Element} The rendered BookACall modal component
 */
const BookACall = ( {onClickBookACall, onClickCancelButton}) => {

    const [bookACallButtonEvent, setBookACallButtonEvent] = useState("Book a Call");

    
    /**
     * Action to take when the user clicks outside the Book a Call modal.
     * Close the modal only if the user isn't being redirected to Hubspot.
     */
    const onClickOutsideModal = () => {
        if (bookACallButtonEvent !== LOADING) {
            onClickCancelButton();
        }
    };

    return (
        <div className={styles.bookACallOverlayStyle} onClick={() => onClickOutsideModal()}>
            <div className={styles.bookACallModalStyle} onClick={(e) => e.stopPropagation()}>
                <h1 className={styles.bookACallTitle}>Book a call</h1>
                <p className={styles.bookACallParagraph}>
                    In order to gain access to QMENTA Platform you need to book a short introduction call<br />with our team member
                </p>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "16px", width: "100%", marginTop: "24px" }}>
                    <div style={{ width: "60%", display: "flex", gap: "16px"}}>
                        <Btn
                            stylebutton={"secondary"}
                            title="Cancel"
                            event={bookACallButtonEvent === LOADING ? DISABLED : "Cancel"}
                            onClick={() => onClickCancelButton()}
                        />
                        <Btn
                            stylebutton={"primary"}
                            event={bookACallButtonEvent}
                            onClick={() => onClickBookACall(setBookACallButtonEvent)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookACall;